// extracted by mini-css-extract-plugin
module.exports = {"loading":"dD","fullscreenWrapper":"dE","centeredSpinner":"dF","rotation":"dG","withoutLayer":"dH"};